import { h } from 'preact'
import ButtonControl from '../../button-control'

interface Props {
    id: number,
    url: string,
    isInvite: boolean
}

const ActionCell = (openCancelInvitation : (id: number) => void) => {
  return ({ id, url, isInvite }: Props) => {
    return (
      <div className='team-overview__table-action'>
        { isInvite ? <ButtonControl title='Cancel invitation' variant='warning' onClick={() => openCancelInvitation(id)} />
          : <a href={url} target='_blank' className='team-overview__table-action__link'>
            <ButtonControl title='Edit role' variant='secondary' class='action__link' />
          </a> }
      </div>
    )
  }
}

export default ActionCell
